import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useInspectionsUiAlignmentEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsUiAlignment,
    false
  );

  return Boolean(isEnabled);
}
